import { RECEIVE_VARIABLE } from '../constants/variable';

const initialState = [];

const reducer = function variableReducer(state = initialState, action) {
	const newState = [...state];
	switch (action.type) {
		case RECEIVE_VARIABLE:
			if (!action.response || action.response.result.length === 0) {
				return newState;
			}
			const variables = action.response.result;
			return variables;
		case 'UPDATE_VARIABLE':
			if (action.key) {
				if (newState.find(v => v.key_ == action.key)) {
					return newState.map(v => {
						if (v.key_ == action.key) v.value = action.value;
						return v;
					});
				} else {
					return [...newState, { key_: action.key, value }];
				}
			}
			return newState;
		default:
			return state;
	}
};

export default reducer;
